import React from "react";
import { Stack, Typography } from "@mui/material";

type Props = {
  text: string;
  number: string;
};

export const Total: React.FC<Props> = ({ text, number }) => {
  return (
    <Stack
      direction="row"
      sx={{ display: "flex", justifyContent: "space-between", m: 4 }}
    >
      <Typography fontWeight={"bold"}>{text}</Typography>
      <Typography>{number}</Typography>
    </Stack>
  );
};
